import "./about.scss";

import PageTitleBreadcrumb from "@frontend/js/Components/Shared/PageTitleBreadcrumb/PageTitleBreadcrumb";
import ClientsList from "@frontend/js/Components/Shared/ClientsList/ClientsList";
import CommunicationIcon from "@frontend/images/icons/CommunicationIcon";
import MetaHead from "@frontend/js/Components/Shared/MetaHead/MetaHead";
import StrategicIcon from "@frontend/images/icons/StrategicIcon";
import MarketingIcon from "@frontend/images/icons/MarketingIcon";
import IncognitoIcon from "@frontend/images/icons/IncognitoIcon";
import ArrowArcIcon from "@frontend/images/icons/ArrowArcIcon";
import QualityImage from "@frontend/images/qualityImage.png";
import PublicIcon from "@frontend/images/icons/PublicIcon";
import UserQIcon from "@frontend/images/icons/UserQIcon";
import SiteLayout from "@frontend/js/Layouts/SiteLayout";
import { usePage } from "@inertiajs/react";
import useT from "@frontend/js/hooks/useT";
import AboutLogistica from "@frontend/js/Components/Site/AboutLogistica/AboutLogistica";

export default function About({ page, blocks = [], meta = {}, clients = [] }) {
    const { t } = useT("site");
    const pageProps = usePage().props;
    const locale = pageProps?.currentLocale;
    const title = page?.title?.[locale] || "";
    const experienceBlock = blocks?.data?.["about-experience-block"] || null;
    const specializationBlocks = [
        blocks?.data?.["about-specialization-block-1"],
        blocks?.data?.["about-specialization-block-2"],
        blocks?.data?.["about-specialization-block-3"],
        blocks?.data?.["about-specialization-block-4"],
    ].filter(Boolean);
    const serviceBlocks = [
        blocks?.data?.["about-service-block-1"],
        blocks?.data?.["about-service-block-2"],
        blocks?.data?.["about-service-block-3"],
    ].filter(Boolean);
    const qualityInfoBlocks = [
        blocks?.data?.["about-quality-info-block-1"],
        blocks?.data?.["about-quality-info-block-2"],
    ].filter(Boolean);
    const teamStatBlocks = [
        blocks?.data?.["about-team-stat-block-1"],
        blocks?.data?.["about-team-stat-block-2"],
        blocks?.data?.["about-team-stat-block-3"],
    ].filter(Boolean);

    return (
        <>
            <MetaHead meta={meta} />

            <SiteLayout>
                <div className="about page-shell">
                    <PageTitleBreadcrumb title={title} />
                    <div className="about__container">
                        {experienceBlock && (
                            <div className="about__container__experience">
                                <h2>{experienceBlock.title_for_site}</h2>
                                <div
                                    className="about__container__experience__text"
                                    dangerouslySetInnerHTML={{
                                        __html: experienceBlock.content,
                                    }}
                                />
                            </div>
                        )}

                        <div className="about__container__specialization">
                            <div className="about__container__specialization__inner">
                                <div className="about__container__specialization__title">
                                    <h2>{t("about-specialization-title")}</h2>
                                    <p>{t("about-specialization-subtitle")}</p>
                                </div>
                                <div className="about__container__specialization__cards">
                                    {specializationBlocks.map(
                                        (block, index) => (
                                            <div
                                                className="about__container__specialization__cards__card"
                                                key={index}
                                            >
                                                {index === 0 && (
                                                    <MarketingIcon />
                                                )}
                                                {index === 1 && <PublicIcon />}
                                                {index === 2 && (
                                                    <StrategicIcon />
                                                )}
                                                {index === 3 && (
                                                    <CommunicationIcon />
                                                )}
                                                <h4>{block.title_for_site}</h4>
                                                <div
                                                    dangerouslySetInnerHTML={{
                                                        __html: block.content,
                                                    }}
                                                />
                                            </div>
                                        ),
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="about__container__services">
                            <div className="about__container__services__inner">
                                <div className="about__container__services__title">
                                    <h2>{t("about-services-title")}</h2>
                                    <p>{t("about-services-subtitle")}</p>
                                </div>
                                <div className="about__container__services__cards">
                                    {serviceBlocks.map((block, index) => (
                                        <div
                                            className="about__container__services__cards__card"
                                            key={index}
                                        >
                                            {index === 0 && <IncognitoIcon />}
                                            {index === 1 && <UserQIcon />}
                                            {index === 2 && <ArrowArcIcon />}
                                            <h4>{block.title_for_site}</h4>
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: block.content,
                                                }}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="about__container__quality">
                            <div className="about__container__quality__title">
                                <h2>{t("about-quality-title")}</h2>
                                <p
                                    dangerouslySetInnerHTML={{
                                        __html: t("about-quality-description"),
                                    }}
                                />
                            </div>
                            <div className="about__container__quality__info">
                                <img src={QualityImage} alt="Quality Control" />
                                <div className="about__container__quality__info__text">
                                    {qualityInfoBlocks[0] && (
                                        <>
                                            <h3>
                                                {
                                                    qualityInfoBlocks[0]
                                                        .title_for_site
                                                }
                                            </h3>
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: qualityInfoBlocks[0]
                                                        .content,
                                                }}
                                            />
                                        </>
                                    )}
                                </div>
                                <div className="about__container__quality__info__list">
                                    {qualityInfoBlocks[1] && (
                                        <>
                                            <h3>
                                                {
                                                    qualityInfoBlocks[1]
                                                        .title_for_site
                                                }
                                            </h3>
                                            <ul>
                                                {qualityInfoBlocks[1].content
                                                    .replace(/<[^>]*>/g, " ")
                                                    .split(";")
                                                    .map((item) => item.trim())
                                                    .filter(Boolean)
                                                    .map((item, index) => (
                                                        <li key={index}>
                                                            {item}
                                                        </li>
                                                    ))}
                                            </ul>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                        <AboutLogistica />
                        <div className="about__container__team">
                            <div className="about__container__team__title">
                                <h2>{t("about-team-title")}</h2>
                                <p>{t("about-team-description")}</p>
                            </div>
                            <div className="about__container__team__cards">
                                {teamStatBlocks.map((block, index) => (
                                    <div
                                        className="about__container__team__cards__card"
                                        key={index}
                                    >
                                        <h3>{block.title_for_site}</h3>
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: block.content,
                                            }}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="about__container__partners">
                            <div className="about__container__partners__title">
                                <h2>{t("about-partners-title")}</h2>
                                <p>{t("about-partners-description")}</p>
                            </div>
                            <div className="about__container__partners__list">
                                <ClientsList clients={clients} />
                                <p>{t("about-partners-clients")}</p>
                                <p
                                    dangerouslySetInnerHTML={{
                                        __html: t("about-partners-award"),
                                    }}
                                />
                            </div>
                        </div>
                        <div className="about__container__confidentiality">
                            <div className="about__container__confidentiality__inner">
                                <h2>{t("about-confidentiality-title")}</h2>
                                <p>{t("about-confidentiality-description")}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </SiteLayout>
        </>
    );
}
